import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  TextField,
  Typography
} from "@mui/material";
import { FormEvent, useState } from "react";
import { TagCategory } from "../../models/tagCategory";
import { useCreateTagCategory } from "../../hooks/tagCategories/useCreateTagCategory";

type CreateTagCategoryProps = {
  handleClose: () => void;
};

export const CreateTagCategory = ({
  handleClose
}: CreateTagCategoryProps) => {
  const [tagCategoryState, setTagCategoryState] = useState<
    Partial<TagCategory>
  >({
    id: undefined,
    name: undefined,
    description: undefined,
    tags: []
  });

  const [error, setError] = useState("");

  const createTagCategory = useCreateTagCategory({
    onSuccess: () => {
      handleClose();
    },
    onError: (error: Error) => {
      setError(error.message);
    }
  }
);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    createTagCategory.mutate(tagCategoryState);
  }

  return (
    <>
        <Box component={"form"} onSubmit={handleSubmit}>
          <Box padding={2}>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                value={tagCategoryState?.name}
                onChange={(e) =>
                  setTagCategoryState({
                    ...tagCategoryState,
                    name: e.target.value
                  })
                }
                label="Name"
                name="name"
                required
                fullWidth
                size="small"
              />
              <TextField
                value={tagCategoryState?.description}
                onChange={(e) =>
                  setTagCategoryState({
                    ...tagCategoryState,
                    description: e.target.value
                  })
                }
                label="Description"
                name="description"
                required
                fullWidth
                size="small"
              />
              <Typography color="error">{error}</Typography>
            </Box>
          </Box>
          <Box padding={2}>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={
                !tagCategoryState?.name || !tagCategoryState?.description
              }
              loading={createTagCategory.isLoading}
            >
              Create
            </LoadingButton>
          </Box>
        </Box>
    </>
  );
};
